import React from 'react';
import {Button, Checkbox, Header, Loader, Message, Segment, Table} from 'semantic-ui-react';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import { FormattedMessage } from 'react-intl';
import { center } from '../Statistics/util';

axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
//axios.defaults.crossDomain = true;

const MAX_ECTS_IN_SEMESTER = 30;


const currentCoursesRequest = (sspid) => axios.get(`/students/courses/current-semester/${window.$locale || 'bs'}`);
const availableCoursesRequest = (sspid) => axios.get(`/students/courses/optional/${window.$locale || 'bs'}`);


export default class OptionalCourses extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentCourses: [],
            availableCourses: [],
            checkedCourses: [],
            maxRemainingECTS: MAX_ECTS_IN_SEMESTER,
            sspid: '',
            loading: true,
            error: false,

            width: window.innerWidth,

        };
        this.fetchCurrentAndAvailableCourses = this.fetchCurrentAndAvailableCourses.bind(this);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        this.calculateMaxRemainingECTS = this.calculateMaxRemainingECTS.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    UNSAFE_componentWillMount() {
        window.addEventListener('resize', this.handleWindowSizeChange);
    }

// make sure to remove the listener
// when the component is not mounted anymore
    componentWillUnmount() {
        window.removeEventListener('resize', this.handleWindowSizeChange);
    }

    handleWindowSizeChange = () => {
        this.setState({ width: window.innerWidth });
    };

    componentDidMount() {
        this.fetchCurrentAndAvailableCourses();
    }
    onSubmit() {
        const { sspid, checkedCourses } = this.state;
        if (!checkedCourses.length) return;
        const ids = checkedCourses.map(el => el.courseImplementationId);
        axios.post('/students/courses/select-additional', [...ids])
            .then(res => {
                this.fetchCurrentAndAvailableCourses(sspid);
                this.setState({checkedCourses:[]});
            }).catch(err => toast(<FormattedMessage id="common.error" />));
    }

    handleCheckboxChange(courseImplementationId, checked) {
        const { availableCourses, checkedCourses } = this.state;
        const targetCourse = availableCourses.find(el => el.courseImplementationId === courseImplementationId);
       if (checked) {
            // // check if remaining ects after is >0
            // // TODO: extract ects reducer to utils
            // if (checkedCourses.reduce((a, c) => a + c.ects, 0) + targetCourse.ects > this.state.maxRemainingECTS) return;
            // // add
            this.setState({
                checkedCourses: [...checkedCourses, targetCourse]
            });
        } else {
            const filtered = checkedCourses.filter(el => el.courseImplementationId !== courseImplementationId);
            this.setState({
                checkedCourses: filtered
         });
       }
    }

    calculateMaxRemainingECTS() {
        const maxRemainingECTS = MAX_ECTS_IN_SEMESTER - this.state.currentCourses.reduce((a, v) => a + v.ects, 0);
        this.setState({ maxRemainingECTS });
    }
    fetchCurrentAndAvailableCourses(sspid) {
        axios.all([currentCoursesRequest(sspid), availableCoursesRequest(sspid)])
            .then(axios.spread((currentRes, availableRes) => {
                let availableCourses = availableRes.data;

                this.setState({
                    currentCourses: currentRes.data.filter(el => !el.mandatory),
                    availableCourses,
                    checkedCourses: [],
                    maxRemainingECTS: MAX_ECTS_IN_SEMESTER,
                    sspid,
                    loading: false
                }, () => this.calculateMaxRemainingECTS());
            }))
            .catch(err => {
               if(err.response.data === 'Did not find unique student study program semester!'){
                   this.setState({ error: true, loading: false });
               }
            });
    }

    render() {
        const { currentCourses, availableCourses, checkedCourses } = this.state;
        const { width } = this.state;
        const isMobile = width <= 500;
        return (
            <div>
                <Header as="h1">{<FormattedMessage id="student.optionalCourses" />}</Header>
                {this.state.loading ? <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div> :
                    <div>
                <Segment.Group raised>
                    <Segment>
                        <Header as="h3">
                            {<FormattedMessage id="student.availableOptionalCourses" />}
                        </Header>
                    </Segment>
                    {this.state.error ?
                        <Segment>
                            {<FormattedMessage id="student.noCurrentSemesterMessage" />}
                        </Segment>
                        : <Segment >
                            <Message
                                size="tiny"
                                warning
                                // header="."
                                content={<FormattedMessage id="student.selectOptionalCoursesWarning" />}
                            />
                        {availableCourses.length > 0 ?
                            <AvailableCoursesTable
                                data={this.state.availableCourses}
                                checkedCourses={checkedCourses}
                                handleCheckboxChange={this.handleCheckboxChange}
                                maxRemainingECTS={this.state.maxRemainingECTS}
                                onSubmit={this.onSubmit}
                                isMobile={isMobile}
                            /> : <NoAvailableCoursesMessage />}
                    </Segment>}
                </Segment.Group>
                <Segment.Group raised>
                    <Segment>
                        <Header as="h3">{<FormattedMessage id="student.currentCourses" />}</Header>
                    </Segment>
                    {this.state.error ?
                        <Segment>
                            {<FormattedMessage id="student.noCurrentSemesterMessage" />}
                        </Segment>
                        : <Segment >
                        {currentCourses.length ?
                            <CurrentCoursesTable data={currentCourses} />
                            : <NoCurrentCoursesMessage />
                        }
                    </Segment>}
                </Segment.Group>
                    </div>}
                <ToastContainer hideProgressBar />
            </div>
        );
    }
}

const NoAvailableCoursesMessage = () => <span>{<FormattedMessage id="student.noElectiveMessage" />}</span>;
const NoCurrentCoursesMessage = () => <span>{<FormattedMessage id="student.noCoursesMessage" />}</span>;

const AvailableCoursesTable = ({
    data, checkedCourses, handleCheckboxChange, maxRemainingECTS, onSubmit, isMobile
}) => (
    <Table tablet celled selectable stackable>
        <Table.Header>
            <Table.Row>
                <Table.HeaderCell colSpan={10}>{<FormattedMessage id="common.course" />}</Table.HeaderCell>
                <Table.HeaderCell colSpan={2} >{<FormattedMessage id="common.courseCode" />}</Table.HeaderCell>
                <Table.HeaderCell colSpan={2} ><FormattedMessage id="common.ects" /></Table.HeaderCell>
                <Table.HeaderCell colSpan={2}>{<FormattedMessage id="common.lectureExerciseSeminar" />}</Table.HeaderCell>
                <Table.HeaderCell colSpan={1} width={1} textAlign={'center'}>{<FormattedMessage id="common.chose" />}</Table.HeaderCell>
            </Table.Row>
        </Table.Header>
        <Table.Body>
            {data.map(row => (
                <Table.Row key={row.courseImplementationId}>
                    <Table.Cell colSpan={10} verticalAlign="middle">{row.courseName}</Table.Cell>
                    <Table.Cell colSpan={2} verticalAlign="middle" >{row.code}</Table.Cell>
                    <Table.Cell colSpan={2} verticalAlign="middle">{row.ects}</Table.Cell>
                    <Table.Cell colSpan={2} verticalAlign="middle">{row.lectureHours} + {row.exerciseHours} + {row.seminarHours ? row.seminarHours : '0'}</Table.Cell>
                    <Table.Cell colSpan={1} verticalAlign="middle" textAlign='center'>
                        <Checkbox
                            checked={checkedCourses.find(el => el.courseImplementationId === row.courseImplementationId)?checkedCourses.find(el => el.courseImplementationId === row.courseImplementationId).courseImplementationId:false}
                            onChange={(e, { checked }) => handleCheckboxChange(row.courseImplementationId, checked)}
                        />

                    </Table.Cell>
                </Table.Row>
            ))}
        </Table.Body>
        <Table.Footer>
            <Table.Row>
                <Table.HeaderCell colSpan={17}>
                        <Button  floated={!isMobile && 'right'} color='blue' basic='true' disabled={!checkedCourses.length} onClick={onSubmit}>{<FormattedMessage id="student.selectOptionalCourse" />}</Button>
                </Table.HeaderCell>
            </Table.Row>
        </Table.Footer>
    </Table>
);

const CurrentCoursesTable = ({ data }) => (
    <Table tablet celled selectable compact stackable>
        <Table.Header>
            <Table.Row>
                <Table.HeaderCell>{<FormattedMessage id="common.course" />}</Table.HeaderCell>
                <Table.HeaderCell width={2}>{<FormattedMessage id="common.courseCode" />}</Table.HeaderCell>
                <Table.HeaderCell width={1}><FormattedMessage id="common.ects" /></Table.HeaderCell>
                <Table.HeaderCell>{<FormattedMessage id="common.lectureExerciseSeminar" />}</Table.HeaderCell>
            </Table.Row>
        </Table.Header>
        <Table.Body>
            {data.map(row => (
                <Table.Row key={row.courseImplementationId}>
                    <Table.Cell verticalAlign="middle">{row.courseName}</Table.Cell>
                    <Table.Cell verticalAlign="middle" width={2}>{row.code}</Table.Cell>
                    <Table.Cell verticalAlign="middle" width={1}>{row.ects}</Table.Cell>
                    <Table.Cell verticalAlign="middle">{row.lectureHours} + {row.exerciseHours} + {row.seminarHours ? row.seminarHours : '0'}</Table.Cell>
                </Table.Row>
            ))}
        </Table.Body>
    </Table>
);



// WEBPACK FOOTER //
// ./src/views/StudentOptionalCourses/OptionalCourses.js